import { render, staticRenderFns } from "./RelatedPosts.vue?vue&type=template&id=3a3bc7dd&scoped=true&"
import script from "./RelatedPosts.vue?vue&type=script&lang=js&"
export * from "./RelatedPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3bc7dd",
  null
  
)

export default component.exports